/* eslint-disable max-lines */
import { css } from 'styled-components';
import { CFBaseButtonTokens, CFBaseButtonUtils } from '../';
import { rootFocusOutlineEffect } from './interactions';
import { CFTokens } from '../../../../tokens';
export const rootBorder = ({ $disabled, $variant }) => {
    const borderColor = $disabled
        ? CFBaseButtonTokens.COLORS.BORDER_DISABLED[$variant]
        : CFBaseButtonTokens.COLORS.BORDER[$variant];
    switch ($variant) {
        case 'danger-secondary':
        case 'danger-secondary-alternate':
        case 'secondary':
        case 'control':
        case 'control-active':
        case 'control-alternate':
        case 'secondary-alternate':
        case 'success-secondary':
        case 'success-secondary-alternate':
            return css `
        border-style: solid;
        border-width: 1px;
        border-color: ${borderColor};
      `;
        default:
            return css `
        border: 0;
      `;
    }
};
export const rootBorderRadius = ({ $rounded }) => {
    return ($rounded
        ? CFBaseButtonTokens.BORDER_RADIUS.ROUNDED
        : CFBaseButtonTokens.BORDER_RADIUS.DEFAULT);
};
export const rootBoxStyles = ({ $disabled, $focused, $iconOnly, $size = 'md', $variant, $widthPreset, }) => {
    const isVariantStandaloneType = CFBaseButtonUtils.isVariantStandaloneType($variant);
    const gap = CFBaseButtonTokens.GAP[$size];
    const height = isVariantStandaloneType
        ? 'auto'
        : `${CFBaseButtonTokens.HEIGHT[$size]}px`;
    // For this inner container that contains all the visual styling
    // we need to ensure that it fills its Wrapper anytime that wrapper has a specific width
    // otherwise it needs to be just `auto`
    let width;
    switch (true) {
        case $widthPreset === 'full':
        case $widthPreset === 'half':
        case $widthPreset === 'min-160':
        case $iconOnly && !isVariantStandaloneType:
            width = '100%';
            break;
        default:
            width = 'auto';
            break;
    }
    /*
      Paddings change under a few conditions:
      - for most cases we use the padding tokens
      - secondary variant uses a border, so we must subtract 1px for that case
      - iconOnly needs to center without any extra padding so we 0 out in that case
    */
    let blockPadding, inlinePadding;
    switch (true) {
        case $iconOnly || isVariantStandaloneType:
            blockPadding = 0;
            inlinePadding = 0;
            break;
        case $variant === 'danger-secondary':
        case $variant === 'danger-secondary-alternate':
        case $variant === 'secondary':
        case $variant === 'secondary-alternate':
        case $variant === 'control':
        case $variant === 'control-active':
        case $variant === 'control-alternate':
        case $variant === 'success-secondary':
        case $variant === 'success-secondary-alternate':
            blockPadding =
                CFBaseButtonTokens.PADDING.BLOCK[$size] - 1;
            inlinePadding =
                CFBaseButtonTokens.PADDING.INLINE[$size] - 1;
            break;
        default:
            blockPadding = CFBaseButtonTokens.PADDING.BLOCK[$size];
            inlinePadding = CFBaseButtonTokens.PADDING.INLINE[$size];
    }
    return css `
    box-sizing: border-box;
    margin: 0;
    padding: ${blockPadding}px ${inlinePadding}px;
    width: ${width};
    height: ${height};
    display: flex;
    gap: ${gap}px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    ${rootFocusOutlineEffect({ $disabled, $focused, $variant })}
  `;
};
export const rootBackgroundColor = ({ $disabled, $variant, }) => $disabled
    ? CFBaseButtonTokens.COLORS.BACKGROUND_DISABLED[$variant]
    : CFBaseButtonTokens.COLORS.BACKGROUND[$variant];
export const rootShadow = ({ $shadow }) => $shadow
    ? css `
        box-shadow: ${CFTokens.ELEVATION[$shadow.toUpperCase()]};
      `
    : null;
